import { Tokens } from "./types";
import { AxiosRequestConfig } from "axios";
import proxyInstance from "src/config/api/proxyInstance";

export const refreshToken = (config?: AxiosRequestConfig) =>
  proxyInstance.post<Tokens>("users/auth/refresh", null, config);
